















	import Vue from "vue";

    const status_name = ['Новая', 'Выполнено', 'В работу', 'Не отвечает', 'Перезвонить']

	export default Vue.extend({
        props: ['order', 'backendStatus'],
        data() {
            return {
                statusName: status_name,
                statusEnable: this.backendStatus
            }
        },
        created() {
            // this.statusEnable[0] = 1
            // this.statusEnable[1] = 1
        },
        methods: {
            setStatus(status: number) {
                if (status == 1) {
                    $('.dropdown').removeClass('open')
                }
                this.$emit('change', status)            
                this.order.view.status_name = status_name[status]
            }
        }
	})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/table/fields/StatusField.vue